{
  "home": [
    {
      "question": "What is Bavimail?",
      "answer": "A complete email infrastructure platform. Send transactional and marketing emails, manage domains and identities, track deliverability, and process inbound mail, all through a single API and dashboard."
    },
    {
      "question": "How does pricing work?",
      "answer": "Start free, then choose a plan as your usage grows. See current prices, included allowances, and billing options on the pricing page."
    },
    {
      "question": "Do I need a dedicated IP?",
      "answer": "Not to get started. Our shared IP pools are carefully managed for high deliverability. Dedicated IPs are available for larger commercial arrangements when you need full reputation control."
    },
    {
      "question": "Can I migrate from another provider?",
      "answer": "Yes. Our REST API follows standard conventions, so most integrations translate directly. Most teams complete migration in under a day. We also provide guides for common providers."
    },
    {
      "question": "Can I use Bavimail for both transactional and marketing emails?",
      "answer": "Yes. Bavimail handles transactional emails like password resets and order confirmations, as well as marketing sends like newsletters and announcements, all through the same API and dashboard."
    },
    {
      "question": "What languages and SDKs do you support?",
      "answer": "Official SDKs are available for TypeScript and Python. The HTTP API also works with any language that can make standard HTTPS requests."
    }
  ],
  "pricing": [
    {
      "question": "How does Bavimail pricing work?",
      "answer": "Choose a plan from the current catalog below. Manage your subscription and billing in the dashboard, where you can also track email usage and retained storage."
    },
    {
      "question": "Do I need a credit card to start?",
      "answer": "No. You can start on the free plan without a credit card and move to a paid plan when you need more included usage or storage."
    },
    {
      "question": "What changes between plans?",
      "answer": "Plans differ in included email usage, domains, inboxes, webhooks, and retained storage. The cards show the current allowances and billing terms."
    },
    {
      "question": "Can larger teams get custom pricing?",
      "answer": "Yes. Reach out if you need a larger commercial arrangement, dedicated infrastructure, or a broader support package."
    },
    {
      "question": "Do I need a credit card to start?",
      "answer": "No. You can start on the free plan without a credit card, send and receive email, verify a domain, and wire up webhooks. Upgrade when you need more included capacity or higher rate limits."
    },
    {
      "question": "Where do I see live pricing?",
      "answer": "The pricing page at /pricing shows the current commercial catalog, pulled from our billing provider so the numbers always match checkout. If you need custom pricing for dedicated infrastructure or a larger commercial arrangement, reach out from that page."
    },
    {
      "question": "Is there a free tier?",
      "answer": "You can start free without a credit card. See the current free-plan allowances above."
    },
    {
      "question": "How do annual billing and overages work?",
      "answer": "Monthly and annual options are shown only when available in the catalog. Review the billing amount, included usage, and overage terms on your selected plan and at checkout. Contact support if a limit or charge is unclear."
    }
  ]
}
